<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="8">
                    <a-row :gutter="10">
                        <a-col :span="11">
                            <a-input v-model="keyword" placeholder="搜索VIN码/车辆型号/品牌/车系" />
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button type="primary" @click="open_add()" v-if="$Func.check_rank('vin_add')">添加VIN码</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading" :pagination="page" bordered>
            <template slot="source" slot-scope="text, record">
                <a-tag :color="record.source === 0 ? 'blue' : 'green'">{{ record.source_str }}</a-tag>
            </template>
            <template slot="car_type" slot-scope="text">
                <a v-if="text" @click="go_car_list(text)">{{ text }}</a>
                <span v-else>-</span>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a @click="()=>{update_data(record)}" v-if="$Func.check_rank('vin_add')">编辑</a>
                <a-divider type="vertical" />
                <a @click="()=>{delete_data(record)}" v-if="$Func.check_rank('vin_del')">删除</a>
            </template>
        </a-table>
        <a-drawer
          title="VIN码记录"
          :width="600"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="add_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="add_model=false"
           v-if="$Func.check_rank('vin_add')"
        >
            <a-form-model :model="info_add" :rules="add_rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-model-item ref="vin" prop="vin" label="VIN码（17位车架号）">
                            <a-input v-model="info_add.vin" placeholder="请输入17位VIN码" :maxLength="17" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="type" prop="type" label="车辆型号">
                            <a-input v-model="info_add.type" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="brand" prop="brand" label="品牌">
                            <a-input v-model="info_add.brand" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="series" prop="series" label="车系">
                            <a-input v-model="info_add.series" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="year" prop="year" label="年份">
                            <a-input v-model="info_add.year" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-model-item ref="engine" prop="engine" label="发动机/电机型号">
                            <a-input v-model="info_add.engine" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <div :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }">
                    <a-button :style="{ marginRight: '8px' }" @click="add_model=false">
                        取消
                    </a-button>
                    <a-button type="primary" html-type="submit">
                        确定
                    </a-button>
                </div>
            </a-form-model>
        </a-drawer>
    </div>
</template>

<script>
    import Func from '../../common/func';
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: 'VIN码',
            dataIndex: 'vin',
            key: 'vin',
            width: 200,
        },
        {
            title: '车辆型号',
            dataIndex: 'type',
            key: 'type',
            width: 180,
            scopedSlots: { customRender: 'car_type' },
        },
        {
            title: '品牌',
            dataIndex: 'brand',
            key: 'brand',
        },
        {
            title: '车系',
            dataIndex: 'series',
            key: 'series',
        },
        {
            title: '年份',
            dataIndex: 'year',
            key: 'year',
            width: 80,
        },
        {
            title: '发动机/电机型号',
            dataIndex: 'engine',
            key: 'engine',
            width: 160,
        },
        {
            title: '来源',
            dataIndex: 'source_str',
            key: 'source',
            width: 100,
            scopedSlots: { customRender: 'source' },
        },
        {
            title: '创建时间',
            dataIndex: 'created',
            key: 'created',
            width: 180,
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: 120,
            key:'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    export default {
        name: 'VinList',
        data(){
            return {
                base_url:Func.api_url,
                columns,
                keyword:'',
                tableData:[],
                loading:false,
                add_model:false,
                info_add:{},
                add_rules: {
                    vin:[{ required: true, message: '请输入VIN码', trigger: 'blur' }],
                    type:[{ required: true, message: '请输入车辆型号', trigger: 'blur' }],
                },
                page:{
                    current:1,
                    total:0,
                    pageSize:10
                }
            }
        },
        mounted() {
            this.get_data();
        },
        methods: {
            change_filter(pagination){
                this.get_data(pagination.current);
            },
            get_data(page,tip) {
                var keyword = this.keyword;
                if (!page) {
                    page = this.page.current||1;
                }
                if(!tip){
                    this.loading = true
                }
                Func.url_get({
                    action:'vin',
                    keyword: keyword,
                    page: page
                },(res) => {
                    if (res.error === 0) {
                        this.tableData = res.info.list;
                        var pagination={
                            pageSize:10,
                            total:res.info.foot.total,
                            current:parseInt(res.info.foot.current)
                        }
                        this.page=pagination;
                        this.loading = false
                    } else {
                        this.$message.error(res.info);
                    }
                });
            },
            open_add(){
                this.info_add = {};
                this.add_model = true;
            },
            add_data(e){
                e.preventDefault();
                this.$refs.add_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'vin.add_data',
                            ...this.info_add,
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.add_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
            update_data(item){
                const it = JSON.parse(JSON.stringify(item));
                Func.url_get({
                    action:'vin.find_data',
                    id:it.id
                },(res) => {
                    this.info_add = res.info;
                });
                this.add_model = true;
            },
            delete_data(item){
                if(confirm('确定要删除吗')==true){
                    Func.url_get({
                        action:'vin.del_data',
                        id:item.id
                    },(res) => {
                        if(res.error===0){
                            this.$message.success(res.info);
                            this.get_data(1,true);
                        }else{
                            this.$message.error(res.info);
                        }
                    });
                }
            },
            go_car_list(type){
                this.$router.push('/car/list?keyword=' + encodeURIComponent(type));
            },
        }
    }
</script>
